import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { AprobacionStore } from '../../stores';

import { Tag } from 'antd';

interface AprobacionHeaderProps {
    aprobacionStore?: AprobacionStore;
}

const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

const HeaderContainer = styled.div`
    text-align: center;
`;

@inject('aprobacionStore')
@observer
export class AprobacionHeader extends React.Component<AprobacionHeaderProps, {}> {
    displayEnviadoFormInformation = () => {
        const { aprobacionStore } = this.props;
        const form = aprobacionStore!.selectedForm!;

        return (
            form && (
                <>
                    <PageHeader>Municipio: {form.municipioNombre}</PageHeader>
                    <Tag color={'#a7a7a7'}>
                        {aprobacionStore!.monthString} - {form.ejercicio}
                    </Tag>
                </>
            )
        );
    };

    render() {
        const { aprobacionStore } = this.props;
        const typo =
            aprobacionStore!.selectedForm !== null
                ? aprobacionStore!.selectedForm!.tipoImpuesto
                : null;

        return (
            <HeaderContainer>
                <PageHeader>Revisión de Capturas {typo}</PageHeader>
                {this.displayEnviadoFormInformation()}
            </HeaderContainer>
        );
    }
}
